import React from 'react';
import { Paper, Typography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  card: { padding: 18, height: '100%', boxSizing: 'border-box' },
  label: { color: '#6b7280', fontSize: 13, fontWeight: 500 },
  value: { fontSize: 28, fontWeight: 700, marginTop: 6, color: '#111827', lineHeight: 1.1 },
  sub: { color: '#9ca3af', fontSize: 12, marginTop: 4 },
}));

type Props = { label: string; value: React.ReactNode; sub?: React.ReactNode };

const StatCard: React.FC<Props> = ({ label, value, sub }) => {
  const classes = useStyles();
  return (
    <Paper className={classes.card} elevation={1}>
      <Typography className={classes.label}>{label}</Typography>
      <Typography className={classes.value}>{value}</Typography>
      {sub !== undefined && sub !== null && <Typography className={classes.sub}>{sub}</Typography>}
    </Paper>
  );
};

export default StatCard;
